import { ref } from 'vue'

// Panneau de contexte du binome ouvert en tiroir sous 1280 px (mobile,
// tablette), ou la troisieme colonne n'a pas la place. Etat partage entre
// l'en-tete de conversation (bouton) et la page de chat (tiroir).
const isChatContextSheetOpenRef = ref(false)

export default function useChatContextSheet() {
  function setChatContextSheetOpen(open: boolean) {
    isChatContextSheetOpenRef.value = open
  }

  return {
    isChatContextSheetOpenRef,
    openChatContextSheet: () => setChatContextSheetOpen(true),
    setChatContextSheetOpen,
  }
}
